import Head from 'next/head';
import React, { useMemo } from 'react';

import { AdsContext, OptiDigitalAdsProps } from '@/core/lib/ads/ads.context';

const OptiDigitalAds: React.FC<OptiDigitalAdsProps> = ({ adUnitPage, children }) => {
  const adUnit = `/22963265510,23187251655/23187251655/od.donnons.org/${adUnitPage}`;
  const dataConfig = {
    adUnit,
  };
  return (
    <>
      <Head>
        <script type="module" id="optidigital-ad-init" async src="//scripts.opti-digital.com/modules/?site=donnons" data-config={JSON.stringify(dataConfig)} key={adUnit}></script>
      </Head>
      {children}
    </>
  );
};

const OptiDigital: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useMemo(
    () => ({
      Ad: () => null,
      OptiDigitalAds,
      isLoaded: true,
      Interstitial: () => null,
      showReward: () => {},
    }),
    [],
  );

  return (
    <AdsContext.Provider value={value}>
      <Head>
        <link rel="preload" href="https://securepubads.g.doubleclick.net/tag/js/gpt.js" as="script" type="text/javascript" />
        <script dangerouslySetInnerHTML={{ __html: 'var optidigitalQueue = optidigitalQueue || {}; optidigitalQueue.cmd = optidigitalQueue.cmd || [];' }}></script>
      </Head>
      {children}
    </AdsContext.Provider>
  );
};

export default OptiDigital;
